import { useState, useCallback } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';

export interface UpdateCommunicationInputPayload {
  defTitle?: string;
  defDescription?: string;
  defSendStart?: string;
  defNotSendable?: number;
  targetTitle?: string;
  targetDescription?: string;
  targetQueryId?: number;
  creationPayload?: Record<string, unknown>;
}

const useUpdateCommunicationInput = () => {
  const { authFetch, isReady } = useAuthenticatedFetchWithWorkspace();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const updateCommunicationInput = useCallback(
    async (id: number, payload: UpdateCommunicationInputPayload): Promise<boolean> => {
      if (!isReady) return false;
      setIsLoading(true);
      setError('');
      try {
        await authFetch(`/communication_inputs/${id}`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/merge-patch+json',
            Accept: 'application/ld+json',
          },
          body: JSON.stringify(payload),
        });
        return true;
      } catch (err: unknown) {
        setError(err instanceof Error ? err.message : 'Erreur lors de la mise à jour de la communication');
        return false;
      } finally {
        setIsLoading(false);
      }
    },
    [authFetch, isReady]
  );

  return { updateCommunicationInput, isLoading, error };
};

export default useUpdateCommunicationInput;
